<template>
    <div>
        <input
            v-model="value"
            type="text"
            :placeholder="placeholder"
            @keyup.enter="$emit('submit')"
            @focus="optionsOpen = true"
            @blur="optionsOpen = false"
        />
        <div v-if="optionsOpen" class="combo-dropdown">
            <ul class="combo-options">
                <li
                    v-for="option in autoCompleteOptions"
                    :key="option"
                    class="combo-option"
                    @mousedown.prevent="selectOption(option)"
                >
                    {{ option }}
                </li>
            </ul>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import Vue from 'vue';
import { Component, Prop, Model } from 'vue-property-decorator';

@Component()
export default class VrmDropdownCombo extends Vue {
    @Prop({ type: Array, default: () => [] })
    options;
    @Prop({ type: String, required: false })
    placeholder;

    @Model('input', { default: null })
    model;

    optionsOpen = false;

    get value() {
        return this.model;
    }

    set value(newValue) {
        this.$emit('input', newValue);
    }

    get autoCompleteOptions() {
        return this.options.filter(str => str.startsWith(this.value));
    }

    selectOption(option) {
        this.value = option;
        this.$emit('submit');
    }
}
</script>
